import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export const actionType = {
  GetUnmappedTeams: "[RECONCILIATION] GET_UNMAPPED_TEAMS",
  ResolveTeam: "[RECONCILIATION] RESOLVE_TEAM",
};

const initialState = {
  unmapped_teams: { data: [], isFetched: false },
};

export const reducer = persistReducer(
  { storage, key: "reconciliation", whitelist: [] },
  (state = initialState, action) => {
    switch (action.type) {
      case actionType.GetUnmappedTeams: {
        return {
          ...state,
          unmapped_teams: {
            data: action.payload.items,
            count: action.payload.total,
            page: action.payload.page,
            pages: action.payload.pages,
            rowsPerPage: action.payload.per_page,
            isFetched: true,
          },
        };
      }

      case actionType.ResolveTeam: {
        // Remove resolved team from the unmapped list — once a sport is
        // assigned the team is no longer unmapped.
        const resolved = action.payload.team;
        const next = state.unmapped_teams.data.filter(
          (t) => t.id !== resolved.id
        );
        return {
          ...state,
          unmapped_teams: { ...state.unmapped_teams, data: next },
        };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  setUnmappedTeams: (data) => ({
    type: actionType.GetUnmappedTeams,
    payload: data,
  }),
  resolveTeam: (data) => ({
    type: actionType.ResolveTeam,
    payload: data,
  }),
};
